// src/components/battle/BattleCardList.jsx
import BattleCard from "./BattleCard";

export default function BattleCardList({ battles, loading, onSelectBattle }) {
  if (loading) {
    return (
      <div className="mt-3 text-center text-xs text-slate-400">
        불러오는 중...
      </div>
    );
  }

  if (!battles || battles.length === 0) {
    return (
      <div className="mt-3 text-center text-xs text-slate-400">
        대결이 없습니다.
      </div>
    );
  }

  return (
    <div className="mt-5 flex flex-col gap-6 px-2">
      {battles.map((battle) => (
        <BattleCard
          key={battle.battleId}
          battle={battle}
          onSelect={onSelectBattle}
        />
      ))}
    
    </div>

    
  );
}
